import { useTheme } from '@emotion/react';
import { Alert, Menu, MenuItem, Link, Divider } from '@mui/material';
import React from 'react';
import { useLocalStorage } from 'react-use';
import __t from '../../../lib/traduzioni';
import { BSSConfirmDialog } from '../../form/BSSDialog';
import { nextUrlByStep } from '../../preventivo/frammenti/FrammentoRiepilogo';
import { defaultStatoMenu, orderHrefBuilder, spedizioneDaOrdine } from './utils';
import useBSSLogger from "../../../hooks/useBSSLogger";
import { grey } from "@mui/material/colors"
import { getContrastRatio } from '@mui/system';
import { tabsDettaglio } from './utils';
import BSSMenu, {leftMenuAlignment} from '../../form/BSSMenu';

const {logger} = useBSSLogger();

const AzioniOrdine = ({stati, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica}) => {

    const [preventivoStorage, aggiornaPreventivoStorage, rimuoviPreventivoStorage] = useLocalStorage("spedizioniweb2_preventivo_form");

    const theme = useTheme()
    
    const {ordine = null} = statoMenu;

    const duplica = async (ordine) => {                
        
        let preventivo = await spedizioneDaOrdine(ordine)

        logger.debug("procedo con la duplica dell'ordine", ordine, preventivo);
        rimuoviPreventivoStorage();
        
        //aggiorno il preventivo nello storage 
        aggiornaPreventivoStorage(preventivo);                
        
        //faccio il redirect allo step 1
        location.href = nextUrlByStep(preventivo.step, [{tipo: "success", messaggio: __t("preventivogeneratodaordine", [ordine.codiceordine])}]);
        
    }

    const MenuProps = {        
        anchorEl: statoMenu.anchorEl,
        open: statoMenu.open,
        onClose: e => {setStatoMenu({...defaultStatoMenu})},                                  
        sx: {
            height: 250,
            '& .MuiMenuItem-root': {
                cursor: "pointer",
                fontSize: 12,
                '&:nth-of-type(even)': {                            
                    backgroundColor: BSSComps_spedizioniweb2_theme.palette.mode === 'light' ? grey[200]: grey[800]
                },       
                '&:hover': {
                    backgroundColor: 'primary.main',
                    color: getContrastRatio("#fff", theme.palette.primary.main) >= getContrastRatio("#000", theme.palette.primary.main) ? "#fff" : "#000"
                }
            }
        }
    }

    return ordine !== null && (
        <>            
            <BSSMenu
                {...{MenuProps}}
            >
                <MenuItem key={"item_duplica"} onClick={e => {
                    logger.debug("apro il dialog di duplica ordine", ordine)
                    setStatoMenu({...statoMenu, open: false})
                    setDialogDuplica({...dialogDuplica, open: true})
                }}>                
                    {__t("duplicaordine")}
                </MenuItem>   
                {(statoMenu.avoidTabs !== true) && [                    
                    <Divider key={"dividerAvoidTabs"} />,
                    tabsDettaglio.map((tab, indiceTab) => {
                        return (
                            <MenuItem 
                                key={`tab_${indiceTab}`} 
                                component={Link} href={orderHrefBuilder({ordine, tab: indiceTab})}
                                onClick={e => {
                                    logger.debug("apro il dialog di duplica ordine", ordine) 
                                    setStatoMenu({...statoMenu, open: false})
                                    
                                }}
                            >           
                                {tab.label}     
                            </MenuItem>
                        ) 
                    })
                ]}      
            </BSSMenu>

            <BSSConfirmDialog 
                open={dialogDuplica.open} 
                undoAction={e => setDialogDuplica({open: false, ordine})} 
                confirmAction={e => duplica(ordine)}
                title={__t("spedizionedaordine")}
            >
                <Alert severity={"warning"}>
                    {__t("questionconfermmodificapreventivo")}
                </Alert>
            </BSSConfirmDialog>            
        </>
    )
}

export default AzioniOrdine;